export const BROWSER = Object.freeze({
  IE: 'IE',
  UNKNOWN: 'UNKNOWN'
});

const getBrowser = () => {
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    return BROWSER.IE;
  }
  return BROWSER.UNKNOWN;
};

export default getBrowser;
